module.exports = __webpack_public_path__ + "static/media/slide3.aa5deb32.jpg";